import { render } from "./CompleteDetailsView.vue?vue&type=template&id=08039c96&ts=true"
import script from "./CompleteDetailsView.vue?vue&type=script&lang=ts"
export * from "./CompleteDetailsView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__